/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { mapModifiers } from 'libs/component';
import { Heading } from 'components/atoms/heading';
import Default from 'components/templates/default';
import { Section } from 'components/molecules/section';
import { OptionList } from 'components/molecules/option-list';
import { PRIVACY_POLICY_LIST } from 'libs/constants';
import { Waypoint } from 'react-waypoint';
import { useTranslation } from 'react-i18next';
import { SUSTAIN_OPTION_LIST,CERTIFICATE_LIST ,PARTNERSHIP_LIST} from 'libs/constants';
import { useEffect } from 'react';

export interface MediaProps {
  currentTab?: number;
  onOptionSelected?: (tab: number) => void;
  onNewsClick?: (slug: string) => void;
}

export const PrivacyPolicy: React.FC<MediaProps> = ({ currentTab: defaultCurrentTab = 0,onOptionSelected}) => {
  const { i18n } = useTranslation();
  const [currentTab, setCurrentTab] = useState<number>(defaultCurrentTab);
  // const [currentTab, setCurrentTab] = useState<number>(defaultCurrentTab);
  
  const optionList = useMemo(() => {
    return SUSTAIN_OPTION_LIST;
  }, []);
  useEffect(() => {
    setCurrentTab(defaultCurrentTab);
  }, [setCurrentTab, defaultCurrentTab, currentTab]);

  const handleOptionSelected = useCallback(
    (index: number) => {
      setCurrentTab(index);
      if (onOptionSelected) {
        onOptionSelected(index);
      }
    },
    [setCurrentTab, onOptionSelected]
  );
  
  const optionItemList = optionList.map(x => (x.label as any)[i18n.language]);
 
  const [ ,setCurrentTopicIndex] = useState(0);
  const policyRef = useRef(null);

  const privacyPolicyList = useMemo(() => {
    return PRIVACY_POLICY_LIST.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const CertificateList = useMemo(() => {
    return CERTIFICATE_LIST.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  const PartnershipList = useMemo(() => {
    return PARTNERSHIP_LIST.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

 

  const handleSectionEnter = useCallback((index: number) => {
    setCurrentTopicIndex(index);
  }, []);



  return (
    <div className={mapModifiers('t-privacy-policy')}>
      <Default>
        <article className="t-privacy-policy__content">
          <Section className="t-privacy-policy__heading">
            <Heading>可持续性</Heading>
            <Section className="t-media__tabs">
              <OptionList
                currentIndex={currentTab}
                modifiers="horizontal"
                items={optionItemList}
                onSelected={handleOptionSelected}
              />
            </Section>
          </Section>



          {currentTab === 0 && (
          <Section className="t-privacy-policy__detail t-privacy-policy__detail--sustain">
            <div className="t-privacy-policy__info" ref={policyRef}>
              {privacyPolicyList.map((policy: any, index: number) => (
                <div key={index} className="t-privacy-policy__info-detail-holder">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-privacy-policy__info-detail"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
          )}


          {currentTab === 1 && (
          <Section className="t-privacy-policy__detail">
            <div className="t-privacy-policy__info" ref={policyRef}>
              {CertificateList.map((policy: any, index: number) => (
                <div key={index} className="t-privacy-policy__info-detail-holder">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-privacy-policy__info-detail"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
          )}

          {currentTab === 2 && (
          <Section className="t-privacy-policy__detail">
            <div className="t-privacy-policy__info" ref={policyRef}>
              {PartnershipList.map((policy: any, index: number) => (
                <div key={index} className="t-privacy-policy__info-detail-holder">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-privacy-policy__info-detail"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
          )}



        </article>
      </Default>
    </div>
  );
};
